module.exports = __webpack_public_path__ + "img/02-light.0f8399e9.png";